'use client'

import { cn } from '@/core/lib/utils/cn'
import { useAuth } from '@/core/store/auth'
import { CopyButton } from '@/core/ui/atoms/copy-button'
import { Heart, Share } from 'lucide-react'
import React from 'react'
import { useToggleFav } from '../../hooks/use-toggle-fav'
import { ProductDetails } from '../../model/product.model'
import { Attributes } from './attributes'

type Props = { product: ProductDetails; reviews: React.ReactNode }

export function ItemDetails({ product, reviews }: Props) {
  const { isFav, toggle } = useToggleFav(product.is_favorite, product.slug)
  const { isAuthenticated } = useAuth()

  return (
    <>
      <article>
        <section className='flex flex-col items-start justify-between gap-4'>
          <h1 className='text-mountain-bluebird max-w-[90%] text-base leading-tight sm:text-lg md:text-base lg:text-xl'>
            {product.name}
          </h1>
          <div className='flex gap-3'>
            {product.categories.map((category, index) => (
              <p
                key={index}
                className={`hover:ring-mountain-bluebird ring-mountain-bluebird text-mountain-bluebird flex items-center gap-2 rounded-xs px-2 py-1 text-sm ring-2 transition-colors duration-200 sm:px-3 sm:py-1 sm:text-base md:text-lg`}
              >
                {category.name}
              </p>
            ))}
          </div>
          <div className='flex gap-4 text-xl font-bold sm:text-3xl md:text-2xl'>
            <CopyButton
              variant='text'
              className='p-0'
              copyLink={window.location.href}
            >
              <Share className='text-cyan-blue cursor-pointer transition hover:opacity-50' />
            </CopyButton>
            {isAuthenticated && (
              <button onClick={toggle} className='cursor-pointer'>
                <Heart
                  className={cn(
                    'h-5 w-5 transition-colors duration-300',
                    isFav
                      ? 'text-creamed-cron fill-creamed-cron'
                      : 'text-black',
                  )}
                />
              </button>
            )}
          </div>
        </section>
        <Attributes product={product} />

        {reviews}
      </article>
    </>
  )
}
